import template from './information-pill.html';
import './information-pill.less';
import InformationPillController from './information-pill.controller';

const InformationPillComponent = {
  bindings: {
    text: '<',
    textBefore: '@',
    textAfter: '@',
    icon: '@',
    border: '@',
    isInverted: '<'
  },
  template,
  controller: InformationPillController
};

export default InformationPillComponent;



// WEBPACK FOOTER //
// ./src/components/information-pill/information-pill.component.js